
import { Box, Text, Flex, Icon } from "@chakra-ui/react";
import { FaArrowUp, FaArrowDown, FaEquals } from "react-icons/fa";
import SystematicFactorsStackedAreaChart from "../../../components/charts/SystematicFactorsCharts/SystematicFactorsStackedAreaChart";
import SystematicFactorsStackedBarChart from "../../../components/charts/SystematicFactorsCharts/SystematicFactorsStackedBarChart";

// Trend indicator component
const TrendIndicator = ({ direction }) => {
  switch (direction) {
    case "up":
      return <Icon as={FaArrowUp} color="green.500" />;
    case "down":
      return <Icon as={FaArrowDown} color="red.500" />;
    default:
      return <Icon as={FaEquals} color="gray.500" />;
  }
};

// Observation text component
const ObservationText = ({ observation }) => {
  if (!observation || observation.percentage === 0) {
    return (
      <Text fontSize="sm" color="gray.500">
        No observation data available
      </Text>
    );
  }

  return (
    <Flex align="center" gap={2}>
      <TrendIndicator direction={observation.direction} />
      <Text fontSize="sm">
        Observed {observation.trend} of {observation.percentage}% over{" "}
        {observation.percentage === 100
          ? "all"
          : `${observation.percentage}/7`}{" "}
        years
      </Text>
    </Flex>
  );
};

const Production = ({ graphData, isAuthenticatedUser, observations }) => {
  return (
    <>
      {/* Total Materials Cost Chart */}
      <Box w="100%" mb={6} position="relative">
        <Box
          position="absolute"
          top="2"
          right="2"
          zIndex="1"
          bg="whiteAlpha.800"
          px="2"
          borderRadius="md"
          style={{
            filter: isAuthenticatedUser ? "none" : "blur(3px)",
            pointerEvents: isAuthenticatedUser ? "auto" : "none",
            transition: "filter 0.3s ease",
          }}
        >
          <ObservationText observation={observations?.totalMaterialsCost} />
        </Box>
        <SystematicFactorsStackedAreaChart
          data={graphData.totalMaterialsCost}
          heading="Total Materials Cost"
          dimension={{ width: "100%", height: "230px" }}
        />
      </Box>

      {/* Total Trade Payables Chart */}
      <Box w="100%" position="relative">
        <Box
          position="absolute"
          top="2"
          right="2"
          zIndex="1"
          bg="whiteAlpha.800"
          px="2"
          borderRadius="md"
          style={{
            filter: isAuthenticatedUser ? "none" : "blur(3px)",
            pointerEvents: isAuthenticatedUser ? "auto" : "none",
            transition: "filter 0.3s ease",
          }}
        >
          <ObservationText observation={observations?.totalTradePayables} />
        </Box>
        <SystematicFactorsStackedBarChart
          data={graphData.totalTradePayables}
          heading="Total Trade Payables"
          dimension={{ width: "100%", height: "230px" }}
        />
      </Box>
    </>
  );
};

export default Production;
